export default "__VITE_ASSET__D2yRo4HK__"